<template>
    <v-menu
        v-model="isMenuOpen"
        :close-on-content-click="false"
        :nudge-right="40"
        offset-y
        min-width="290px"
        class="inline ml-2"
        transition="scale-transition"
    >
    <template v-slot:activator="{ on }">
        <v-text-field
        class="inline ml-2"
        readonly
        :label="label"
        v-on="on"
        :value="selectedDate | formatDatePicker"
        ></v-text-field>
    </template>
    <v-date-picker
        v-model="selectedDate"
        @input="onSelect"
    ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
  props: {
    date: String,
    label: {
      type: String,
      default: 'Date'
    },
    didSelect: Function
  },
  data: function () {
    return {
      isMenuOpen: false,
      selectedDate: this.date
    }
  },
  methods: {
    onSelect () {
      console.log(this.selectedDate)
      this.$emit('didSelect', this.selectedDate)
    }
  }
}
</script>
